function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import TagComponent from "./components/tag/tag-component";
import { StyledGridTag } from "./grid-tag.scss";
import DefaultProps from "./default-props";
class GridTag extends PureComponent {
    render() {
        const { tag, fullParagraph, titleSize, textSize } = this.props;
        return /*#__PURE__*/ _jsxs(StyledGridTag, {
            className: "grid-tag",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "tag-component-wrapper",
                    children: /*#__PURE__*/ _jsx(TagComponent, _object_spread({}, tag))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "full-paragraph-component-wrapper",
                    children: /*#__PURE__*/ _jsx(FullParagraph, _object_spread_props(_object_spread({}, fullParagraph), {
                        titleSize: titleSize,
                        textSize: textSize
                    }))
                })
            ]
        });
    }
}
export { GridTag as default };
GridTag.defaultProps = DefaultProps;
